import { FC } from 'react'
import { ContactSiteInfo } from '../../../../../../hooks/useContactSiteInfo'
import OneInputText from '../../../../../UtilComponent/level_2/OneInputText'
import TowInputText from '../../../../../UtilComponent/level_2/TowInputText'

type Props = ContactSiteInfo

const EditContactSiteInfo: FC<Props> = (props) => {
  const {
    siteInput,
    twitterInput,
    linkedInInput,
    facebookInput,
    skypeInput,
    discordInput,
    slackInput,
    githubInput,
    youtubeInput,
    tiktokInput,
    spotifyInput,
  } = props



  return (
    <div className="stack">
      <TowInputText first={siteInput} second={twitterInput} />
      <TowInputText first={linkedInInput} second={facebookInput} />
      <TowInputText first={skypeInput} second={discordInput} />
      <TowInputText first={slackInput} second={githubInput} />
      <TowInputText first={youtubeInput} second={tiktokInput} />
      <OneInputText first={spotifyInput} />
    </div>
  )
}

export default EditContactSiteInfo
